import type { TeamName } from '../types';

export const MAX_ROUNDS = 10;
export const POINTS_PER_ROUND = 3;
export const BASE_SCORE = 20;

export const TEAMS: TeamName[] = ['team1', 'team2', 'team3', 'team4'];

export const IMPACT_TYPES = {
  ECONOMIC: 1,
  SOCIAL: 2,
  SOCIETAL: 3,
  ECOLOGICAL: 4,
} as const;

export const GAME_MODES = {
  TEAMLAB: 'teamlab',
  LEADLAB: 'leadlab',
} as const;

export const LANGUAGES = ['en', 'fr', 'es', 'de', 'nl', 'pt'] as const;
